import { CheckCircleOutlined, CopyOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import React, { FunctionComponent, useEffect, useState } from 'react'

import { BASE_URL } from '../../../../ini.json'

interface BreadcrumbCopyButtonProps {
  copyText: string
}

export const BreadcrumbCopyButton: FunctionComponent<BreadcrumbCopyButtonProps> =
  ({ copyText }) => {
    const [isCopied, setIsCopied] = useState(false)

    const handleCopy = async () => {
      try {
        await navigator.clipboard.writeText(BASE_URL + copyText)
        setIsCopied(true)
      } catch (error) {
        console.error('Failed to copy:', error)
      }
    }

    useEffect(() => {
      let timeoutId: NodeJS.Timeout | undefined

      if (isCopied) {
        timeoutId = setTimeout(() => {
          setIsCopied(false)
        }, 3000)
      }

      return () => {
        if (timeoutId) clearTimeout(timeoutId)
      }
    }, [isCopied])

    return (
      <div className="group opacity-50 hover:opacity-100 transition-opacity ml-1">
        <Button
          size="small"
          type="link"
          ghost={false}
          onClick={isCopied ? undefined : handleCopy}
          icon={isCopied ? <CheckCircleOutlined /> : <CopyOutlined />}
        >
          <span className="opacity-0 group-hover:opacity-100 transition-opacity">
            {isCopied ? 'Zkopírováno' : 'Kopírovat URL'}
          </span>
        </Button>
      </div>
    )
  }
